export default __webpack_public_path__ + "static/media/EM0333.34I-41668_-24936_0.f8b5c8a1.jpg";